import axios from 'axios'
import vue from '@/main'
import {Message} from 'element-ui';
import {SettingMer} from '@/utils/settingMer'
import store from '@/store'
import {createSign} from '../api-sign.js'

const VUE_APP_BASE_API = process.env.VUE_APP_BASE_API
// https://api.p.xn--2nyn50c.com/api/activity/admin/api/
const service = axios.create({
  baseURL: `${VUE_APP_BASE_API}`,
  timeout: 30000,
})

service.interceptors.request.use(
  async config => {
    console.log(config)
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['authori-zation'] = token
      // config.headers['token'] = token
    }
    if (/get/i.test(config.method)) {
      ///直传需要更改基准地址
      if (config.isFile) config.baseURL = SettingMer.uploadApiBaseURL;
      config.params = config.params || {};
      config.params.temp = Date.parse(new Date()) / 1000;
    }
    config.headers['from-type'] = 'pc'

    // 接口验签
    const VUE_APP_BASE_API = process.env["VUE_APP_BASE_API"]
    let apiUrl = config.url
    apiUrl = apiUrl.replace(VUE_APP_BASE_API, '')
    let signData = {}
    const signMethod = config.method.toUpperCase()
    if (signMethod === 'POST' || signMethod === 'PUT') {
      signData = JSON.parse(JSON.stringify(config.data || ''))
    } else if (signMethod === 'GET' || signMethod === 'DELETE') {
      signData = JSON.parse(JSON.stringify(config.params || {}))
    }
    let headers = createSign(apiUrl, signMethod, signData)
    config.headers = Object.assign(config.headers, headers)
    return config;
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const data = response.data || {}
    const code = data.code || 200
    if (code !== 200) {
      Message.warning(data.message)
      if (code === 401) {
        store.commit('common/setToken', '')
        store.commit('common/setApplyId', '')
      }
      return Promise.reject(data)
    } else {
      return response.data
    }
  },
  error => {
    if (!error.response) {
      return Promise.reject(error)
    }
    const data = error.response.data || {}
    // code需要弹框列表
    const list = [400, 100002]
    if (list.indexOf(data.code) !== -1) {
      vue.$Prompt(data.msg)
      return Promise.reject(data)
    } else if (data.code === 401) {
      store.commit('common/setToken', '')
      store.commit('common/setApplyId', '')
    } else {
      return Promise.reject(data)
    }
  }
)
export default service

